// extracted by mini-css-extract-plugin
module.exports = {"comments":"e_y","related":"e_z","breadCrumbs":"e_A","followLine":"e_B","postTags":"e_C","sidebarPostNav":"e_D"};